// extracted by mini-css-extract-plugin
export default {"details__topBarContainer":"PackageEditView_details__topBarContainer__NsjIv"};